//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

// custom pages
import { styles } from "../Promotion/Criteria/styles";
import milestonepromotion from "apis/milestonePromotion/milestonepromotion";
import Context from "context/context";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import Table from "components/Table/Table";
import Autocomplete from "@material-ui/lab/Autocomplete";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import { blue } from '@material-ui/core/colors';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from "@material-ui/core/Checkbox";
import useForm from '../../../helpers/useForm';

// material-ui icons
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import CircularProgress from "@material-ui/core/CircularProgress";
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { useTranslation } from 'react-i18next';
import { Typography } from "@material-ui/core";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function MilestoneCriteriaCreate() {
  const { state, dispatch } = useContext(Context);

  const { createCriteria, searchCategory, getCriteriaAvailablePromo, checkCriteriaExist, checkAndCreateCriteria } = milestonepromotion();
  const history = useHistory();
  const classes = styles();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    category: "",
    searchLoading: false,
    searchData: [],
    searchCategoryValue: "",
    categoryValue: [],
    categoryValueExist: [],
    categoryValueCurrent: [],
    isActive: true,
    type:'Include',
    loading: false,
    criteriaRule: []
  });

  const {
    category,
    searchLoading,
    searchData,
    searchCategoryValue,
    categoryValue,
    categoryValueExist,
    categoryValueCurrent,
    isActive,
    loading,
    type,
    criteriaRule
  } = states;

  const categoryValueDebounce = useDebounce(searchCategoryValue);
  const initialValues = {
    criteriaType: '',
    promoList: ''
  };
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const {
    handleChange,
    errors
  } = useForm(initialValues);
  const [criteriaType, setCriteriaType] = useState(true);
  const [existingPromoData, setExistingPromoData] = useState([]);
  const [existingPromoDataClone, setExistingPromoDataClone] = useState([]);
  const [selectedPromo, setSelectedPromo] = useState();
  const [allCriteria, setAllCriteria] = useState([]);
  const [allPromo, setAllPromo] = useState([]);
  const [selectedAllPromo, setSelectedAllPromo] = useState([]);

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Promotion Management", "Criteria", "Create"],
    });
   
  }, []);

 

  // handling search api call
  useEffect(() => {
    if (categoryValueDebounce && categoryValueDebounce.length > 0) {
      handleSearch();
    }
  }, [categoryValueDebounce]);

  // handleSearch api func
  const handleSearch = async () => {
    setStates({ searchLoading: true });
    try {
      let values;
      values = {
        searchValue: searchCategoryValue,
        category: category,
      };
      let res = await searchCategory(values);
      if (res) {
        setStates({ searchData: res?.data, searchLoading: false });
      }
    }
    catch (e) {
      console.log({ e });
    }
  };

  // create api func
  const handleCreate = async () => {
    try {
      if (!category || categoryValue.length === 0) {
        toast.error("Please fill all the fields", {
          toastId: "required-fields-error",
        });
        setStates({ loading: false });
        return;
      }
      let categoryValueArray = [];
      let promoValueArray = [];

      let mpcCriteria = []
      if (category == "product_primary_class_id") {
        mpcCriteria = categoryValue.map(i => {
          return { name: i?.name, value: i?.value?.replaceAll('-', '') }
        })
      }

      let values;
      values = {
        category,
        categoryValue: category == "product_primary_class_id" ? mpcCriteria : categoryValue,
        isActive,
        type:type,
        program:'THRIVE UNLOCKED'
      };
      let res = await checkAndCreateCriteria(values);
      if (res) {
        let currentArray = [];
        let currentData = res.data;
        if (currentData.length > 0) {
          currentData.map(cv => {
            currentArray.push(cv.category_value);
          });
          setStates({
            categoryValueCurrent: currentArray
          });
        }
        let existArray = [];
        let existData = res.exsistingData;
        if (existData.length > 0) {
          existData.map(cv => {
            categoryValueArray.push(true);
            promoValueArray.push([]);
            existArray.push({ value: cv.category_value });
          });
          setAllCriteria(categoryValueArray);
          setAllPromo(promoValueArray);
          setStates({
            categoryValueExist: existArray
          });
          setModal(true);
        }
        else {
          toast.success("Created", { toastId: "criteria-created" });
          history.goBack();
        }
      }
      setStates({ loading: false });
    }
    catch (e) {
      console.log({ e });
    }
  };
  function reset() {
    handleChange({ name: 'criteriaType', value: '' });
    handleChange({ name: 'promoList', value: '' });
  }
  const handleClose = () => {
    setModal(false);
    reset();
  };
  const handleTypeChange = async (cv, i) => {
    if (allCriteria[i] === true) {
      try {
        dispatch({ type: "SET_LOADING", payload: true });
        let values;
        values = {
          category,
          categoryValue: cv,
          isActive,
          promotionId: location?.state?.id,
          action: 'create'
        };
        let res = await getCriteriaAvailablePromo(values);
        if (res) {
          const newPromoArray = [...allPromo];
          newPromoArray[i] = res.data.map((d, i) => {
            return {
              ...d,
              selected: i == 0 ? true : false
            };
          });
          const firstObjects = [...selectedAllPromo];
          firstObjects[i] = (newPromoArray[i][0]);
          setAllPromo(newPromoArray);
          setSelectedAllPromo(firstObjects)
            
          dispatch({ type: "SET_LOADING", payload: false });
        }
      }
      catch (e) {
        console.log({ e });
      }
    }
  };
  // const handleChecked = (event, values, i) => {
  //   let checked = event.target.checked;
  //   setExistingPromoData(
  //     existingPromoData.map((customer) => {
  //       if (customer.product_primary_class_id == values.product_primary_class_id) {
  //         customer.selected = checked;
  //       }
  //       return customer;
  //     })
  //   );
  //   if (!checked) {
  //     setExistingPromoData([
  //       ...existingPromoData.slice(0, i),
  //       { ...existingPromoDataClone[i] },
  //       ...existingPromoData.slice(i + 1),
  //     ]);
  //   }
  // };
  const GreenRadio = withStyles({
    root: {
      color: blue[400],
      '&$checked': {
        color: blue[600]
      }
    },
    checked: {},
  })((props) => <Radio color='default' {...props} />);
  const handleSelectPromo = async (promo, ci) => {
    try {
      const newPromoArray = [...selectedAllPromo];
      newPromoArray[ci] = promo;
      setSelectedAllPromo(newPromoArray);
      setSelectedPromo(promo.promotion_id);
      return;
    }
    catch (e) {
      console.log({ e });
    }
  };
  const handleSubmit = async () => {
    const trueIndices = [];
    allCriteria.forEach((value, index) => {
      if (value === true) {
        trueIndices.push(index);
      }
    });
    // const valuesofdDoubleDippingcategory = trueIndices.map(index => categoryValue[index]);
    // const valuesofdDoubleprioritycategory = categoryValue.filter((value, index) => !trueIndices.includes(index));
    // const valuesofselectedpromoforpriority = selectedAllPromo.filter((value, index) => !trueIndices.includes(index));
    let values;
    values = {
      category,
      categoryValue: categoryValueExist,
      isActive,
      categoryType: allCriteria,
      categoryValueCurrent: categoryValueCurrent,
      type:type,
      program:'THRIVE UNLOCKED'
    };
    let res = await createCriteria(values);
    if (res) {
      toast.success("Created", { toastId: "criteria-created" });
      history.goBack();
    }
  }
  const checkCriteria = async (c, cv) => {

    let categoryValue;
    if (c == "product_primary_class_id") {
      categoryValue = cv.map(i => {
        return { name: i?.name, value: i?.value?.replaceAll('-', '') }
      })
    } else {
      categoryValue = cv;
    }

    let values = {
      category: c,
      categoryValue: categoryValue,
      isActive,
      promotionId: location?.state?.id
    };
    let res = await checkCriteriaExist(values);
    if (res.data.count > 0) {
      toast.error("Already Exist", {
        toastId: "required-fields-error",
      });
      return;
    }
    else {
      setStates({
        categoryValue: cv,
        searchCategoryValue: ""
      });
    }
  }

  // let org = state?.userInfo?.loyalty_organization_name;

  return (
    <React.Fragment>
      <div className={classes.mainDiv}>

        <Grid container spacing={0} style={{ padding: 10 }}>
          <Grid item xs={12}>
            <IconButton
              onClick={() => {
                history.goBack();
              }}
            >
              <ArrowBackIcon style={{ color: "#305698" }} />
            </IconButton>
            <span style={{ fontSize: 18, fontWeight: "bold" }}>{t('Create')}</span>
          </Grid>
        </Grid>
        <Grid container spacing={2} style={{ padding: 10 }}>
          <Grid item xs={3}>
         
              <CssTextField
                id={"Category"}
                label={t("Category")}
                select
                fullWidth
                type={"text"}
                required
                value={category}
                onChange={(e) => {
                  setStates({
                    category: e.target.value,
                    categoryValue: "",
                    searchCategoryValue: "",
                    searchData: [],
                  });
                }}
              >
                {[
                  { label: "MPC", value: "product_primary_class_id" },
                  { label: "GL Cost Center", value: "business_unit_code" },
                  { label: "Label Class Code", value: "label_class_code" },
                  { label: "Brand", value: "product_brand_name_code" },
                  { label: "Sales Category", value: "loyalty_category_code" },
                  { label: "Product Code", value: "product_code" },
                  { label: "Order Source Code", value: "order_source_code" },
                  { label: "Loyalty Id", value: "loyalty_id" },
                  { label: "Primary Major Class Code", value: "primary_major_class_code" },
                  { label: "Primary Submajor Class Code", value: "primary_submajor_class_code" },
                  { label: "Primary Minor Class Code", value: "primary_minor_class_code" },
                  { label: "Order Promotion Code", value: "order_promotion_code" },
                  { label: "Order Level Coupon", value: "order_level_coupon" },
                  { label: "Line Promo Coupon", value: "line_promo_coupon" },
                  { label: "Equipment Order Number", value: "equipment_order_number" },
                  { label: "Promotion", value: "promotion" },

                ].map((k, i) => (                  
                  <MenuItem value={k.value} key={i}>
                    {t(k.label)}
                  </MenuItem>
                ))}
              </CssTextField>
            {/* <CssTextField
              id={"Category"}
              label={t("Category")}
              select
              fullWidth
              type={"text"}
              required
              value={category}
              onChange={(e) => {
                setStates({
                  category: e.target.value,
                  categoryValue: "",
                  searchCategoryValue: "",
                  searchData: [],
                });
              }}
            >
              {[
                { label: "MPC", value: "product_primary_class_id" },
                { label: "GL Cost Center", value: "business_unit_code" },
                { label: "Label Class Code", value: "label_class_code" },
                { label: "Brand", value: "product_brand_name_code" },
                { label: "Sales Category", value: "loyalty_category_code" },
                { label: "Product Code", value: "product_code" },
                { label: "Order Source Code", value: "order_source_code" },
                { label: "Loyalty Id", value: "loyalty_id" },
                { label: "Primary Major Class Code", value: "primary_major_class_code" },
                { label: "Primary Submajor Class Code", value: "primary_submajor_class_code" },
                { label: "Primary Minor Class Code", value: "primary_minor_class_code" },
              ].map((k, i) => (
                <MenuItem value={k.value} key={i}>
                  {t(k.label)}
                </MenuItem>
              ))}
            </CssTextField> */}
          </Grid>

          <Grid item xs={ 3}>
            {
              <Autocomplete
  multiple
  disabled={!category}
  options={searchData}
  getOptionLabel={(obj) =>
    (states?.category == 'loyalty_id' || states?.category == 'label_class_code' || states?.category == 'order_promotion_code' || states?.category == 'promotion' || states?.category == 'order_level_coupon' || states?.category == 'line_promo_coupon' || states?.category == 'equipment_order_number')
      ? obj?.value
      : obj?.value + ' - ' + obj?.name
  }
  filterOptions={(options) => options}
  inputValue={searchCategoryValue}
  clearOnBlur={true}
  onClose={() => {
    if (!categoryValue) {
      setStates({ searchCategoryValue: "" });
    }
  }}
  value={categoryValue || []}
  onInputChange={(event, newInputValue, reason) => {
    if (reason === "input") {
      setStates({ searchCategoryValue: newInputValue });
    }
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      required
      label={t('Category Value')}
      margin="none"
      InputProps={{
        ...params.InputProps,
        endAdornment: (
          <React.Fragment>
            {searchLoading ? (
              <CircularProgress color="inherit" size={20} />
            ) : null}
            {params.InputProps.endAdornment}
          </React.Fragment>
        ),
      }}
    />
  )}
  onChange={(value, obj, reason) => {
    if (reason === "clear") {
      setStates({ searchCategoryValue: "", categoryValue: [] });
      return;
    }
    if (obj) {
      checkCriteria(category, obj);
    }
  }}
/>
            }
          </Grid>

          <Grid item xs={ 3}>
            <CssTextField
              id="Is Active"
              label={t("Status")}
              select
              fullWidth
              type={"text"}
              required
              value={isActive}
              onChange={(e) => {
                setStates({ isActive: e.target.value });
              }}
            >
              {[
                { label: "Active", value: true },
                { label: "Inactive", value: false },
              ].map((k, i) => (
                <MenuItem value={k.value} key={i}>
                  {t(k.label)}
                </MenuItem>
              ))}
            </CssTextField>
          </Grid>

        
            <Grid item xs={3}>
            <CssTextField
              id="Type"
              label={t("Type")}
              select
              fullWidth
              type={"text"}
              required
              value={type}
              onChange={(e) => {
                setStates({ type: e.target.value });
              }}
            >
              {[
                { label: "Include", value: 'Include' },
                { label: "Exclude", value: 'Exclude' },
              ].map((k, i) => (
                <MenuItem value={k.value} key={i}>
                  {t(k.label)}
                </MenuItem>
              ))}
            </CssTextField>            
            </Grid>
         
        </Grid>
        <Grid container spacing={0} style={{ padding: 10 }}>
          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Button
              className={classes.submitBtn}
              onClick={() => {
                setStates({ loading: true });
                handleCreate();
              }}
              disabled={loading}
            >
              {t('Submit')}
            </Button>
          </Grid>
        </Grid>

      </div>

     

    </React.Fragment>
  );
}
